import classNames from 'classnames';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import DisplayLoading from '../../../common/components/misc/DisplayLoading';
import { CustomerDataState } from '../../../common/services/customer/Types';
import iconHome from '../../assets/images/icons/Cinzentos/Home.svg';
import { RootState } from '../../base/RootReducer';
import { config } from '../../common/';
import { useLocation } from '../../common/RouterHooks';
import { AppThunkDispatch } from '../../common/types';
import Avatar from './Avatar';
import CustomerInfo from './CustomerInfo';
import DataAccess from './DataAccess';
import VehiclesInfo from './VehiclesInfo';

interface ReduxStateProps {
    customerInfo: CustomerDataState;
}

const ProfileLayout: React.FC<ReduxStateProps> = (props) => {
    const { t } = useTranslation();
    const [tab, setTab] = useState(2);
    const location = useLocation();

    const changeTab = (tabIdx: number) => {
        if (tab !== tabIdx) {
            setTab(tabIdx);
        }
    };

    useEffect(() => {
        const op = qs.parse(location.search).op;
        if (op && op === 'addVehicle') {
            setTab(3);
        }
    }, [location.search]);

    // qs.parse(this.props.location.search, { ignoreQueryPrefix: true })

    return (
        <React.Fragment>
            <div className={classNames(['grid-container', 'padding-bottom-4', 'meu-perfil'])}>
                {props.customerInfo.isCommunicating || !props.customerInfo.data || !props.customerInfo.data.customerData ? (
                    <DisplayLoading validation={true} />
                ) : (
                    <div className={classNames(['grid-x', 'grid-margin-x'])}>
                        <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                            <div className={classNames(['grid-container', 'fluid', 'meu-perfil-apresentacao'])}>
                                <div className={'profile-header'}>
                                    <div className={classNames(['profile-header-avatar'])}>
                                        <Avatar />
                                    </div>
                                    <div>
                                        <h1>{t('profile:hello')} {props.customerInfo.data.customerData.firstName}.</h1>
                                        <p>{t('profile:disclaimer')}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={classNames(['cell', 'large-10', 'large-offset-1', 'columns'])}>
                            <ul className={'tabs'} data-active-collapse="true" id="collapsing-tabs">
                                <li className={classNames(['tabs-title', { 'is-active': tab === 2 }])}>
                                    <a onClick={() => changeTab(2)} className={classNames([{ 'text-bold': tab === 2 }])}>
                                        {t('profile:subTitle2')}
                                    </a>
                                </li>
                                <li className={classNames(['tabs-title', { 'is-active': tab === 1 }])}>
                                    <a onClick={() => changeTab(1)} className={classNames([{ 'text-bold': tab === 1 }])}>
                                        {t('profile:subTitle1')}
                                    </a>
                                </li>
                                <li className={classNames(['tabs-title', { 'is-active': tab === 3 }])}>
                                    <a onClick={() => changeTab(3)} className={classNames([{ 'text-bold': tab === 3 }])}>
                                        {t('profile:subTitle3')}
                                    </a>
                                </li>
                                <li className={classNames(['tabs-title', 'float-right'])}>
                                    <a className={'header-btn'} href={config.BaseURL}>
                                        <img src={iconHome} alt={t(`common:home`)} />
                                        {t(`common:home`)}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        {tab === 1 && <DataAccess />}
                        {tab === 2 && <CustomerInfo />}
                        {tab === 3 && <VehiclesInfo />}
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    customerInfo: store.customerState.customerData,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileLayout);
